import { InvoiceReports } from '@/features/invoice_reports';

const InvoiceReportsPage = () => {
  return <InvoiceReports />;
};
export default InvoiceReportsPage;
